import {
    DELETE_USER,
    DELETE_USER_SUCCESS,
    DELETE_USER_ERROR,
  } from '../../../constants/constantsRed';
  
  export const deleteUserManagerRed = (state: any = false, actions: any) => {
    switch (actions.type) {
      case DELETE_USER:
        return {
          ...state,
          loading: true,
        };
      case DELETE_USER_ERROR:
        return {
          data: null,
          loading: false,
          error: null,
        };
      case DELETE_USER_SUCCESS:
        return {
          ...state,
          loading: false,
          error: null,
          data: actions.payload,
        };
      default:
        return state;
    }
  };
  